const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export const getAuthHeaders = () => {
  const token = localStorage.getItem('dentist_token');
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
};

export async function fetchWithAuth(path, options = {}) {
  const token = localStorage.getItem('dentist_token');

  const headers = {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json',
    ...options.headers
  };

  // Remove Content-Type for FormData
  if (options.body instanceof FormData) {
    delete headers['Content-Type'];
  }

  try {
    const response = await fetch(`${API_URL}${path}`, {
      ...options,
      headers
    });

    // Auto-logout on 401 only. A 403 from this API means "authenticated but not
    // permitted" (authorize* middleware), NOT a stale token — authenticate()
    // answers 401 for that. Logging out on 403 would eject a dentist to the
    // login screen for an ordinary permission error, and would swallow the
    // machine code (BRANCH_FORBIDDEN) the caller needs to show a real message.
    if (response.status === 401) {
      localStorage.removeItem('dentist_token');
      localStorage.removeItem('dentist_user');
      window.location.href = '/login';
      return null;
    }

    if (!response.ok) {
      // Some failures (a proxy error, a crash before the JSON body) are not JSON
      // at all; fall back rather than throwing a SyntaxError over the real cause.
      let payload = {};
      try {
        payload = await response.json();
      } catch (_) {
        payload = {};
      }
      const err = new Error(payload.message || `Request failed (${response.status})`);
      // The stable machine code the UI translates on, and the status for callers
      // that need to distinguish 403 from 409 without string-matching.
      err.code = payload.code;
      err.status = response.status;
      err.payload = payload;
      throw err;
    }

    return response.json();
  } catch (error) {
    console.error('API Error:', error);
    throw error;
  }
}

// Get current user from localStorage
export const getCurrentUser = () => {
  const user = localStorage.getItem('dentist_user');
  return user ? JSON.parse(user) : null;
};

// Check if user is authenticated
export const isAuthenticated = () => {
  return !!localStorage.getItem('dentist_token');
};

// Login - store token and user
export const login = (token, user) => {
  localStorage.setItem('dentist_token', token);
  localStorage.setItem('dentist_user', JSON.stringify(user));
};

// Logout - clear storage
export const logout = () => {
  localStorage.removeItem('dentist_token');
  localStorage.removeItem('dentist_user');
  window.location.href = '/login';
};

export { API_URL };
